import Vue from 'vue'
import toastr from 'toastr'
import { DEFAULT_ERROR_MESSAGE } from 'common/constants'
import axios from 'axios'
import createFormStore from '../../vue_widgets/gmb/local_posts/form/store'
import FormWidget from '../../vue_widgets/gmb/local_posts/form/index'
import { updateSearchParams } from '../../common/search_params'
import { toDataUrl } from '../../common/helpers'

function form(params) {
  $(() => {
    new Vue({ // eslint-disable-line no-new
      el: document.getElementById('vue-localpost-form'),
      store: createFormStore(params),
      render: (h) => h(FormWidget)
    })
  })
}

Styxie.Initializers.GmbLocalPosts = {
  new: form,
  edit: form,
  clone: form,
  index: () => {
    $(() => {
      $('.js-posts-sort-select, .js-posts-filter-select')
        .turboSelect({ width: '100%', dropdownAutoWidth: 'true' })
        .on('change', (e) => {
          const $el = $(e.currentTarget)
          const h = {}
          h[$el.prop('name')] = $el.val()
          updateSearchParams(h)
        })

      $('.js-download-file').on('click', (e) => {
        e.preventDefault()
        toDataUrl(e.currentTarget.href, (myBase64) => {
          const link = document.createElement('a')
          link.href = myBase64
          link.download = e.currentTarget.download
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      })

      $('.js-publish-post').on('click', (e) => {
        e.preventDefault()

        const originalText = e.target.innerHTML
        const url = $(e.currentTarget).attr('href')

        e.target.innerHTML = '<i class="far fa-fw fa-spin fa-spinner-third" />'
        e.currentTarget.classList.toggle('disabled')

        axios.post(url)
          .then(() => {
            e.currentTarget.classList.toggle('d-none')
            toastr.success('Post was successfully published in Google')
            window.location.reload()
          })
          .catch((res) => {
            if (res.response.status === 422) {
              if (res.response.data.path) {
                toastr.error('Post wasn\'t published in Google')
                window.location = res.response.data.path
              } else if (res.response.data.errors) {
                toastr.error(res.response.data.errors)
              }
            } else {
              toastr.error(DEFAULT_ERROR_MESSAGE)
            }
            e.target.innerHTML = originalText
            e.currentTarget.classList.toggle('disabled')
          })
      })
    })
  }
}

export default form
